export default {
      id: "grievance-redressal-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#grievance-redressal",
      toString: function () {
        return this.url;
      }
    }